import React, { useEffect } from 'react';
import { getNameClient } from './../../../helpers/nameClient';
import { useSelector, useDispatch } from 'react-redux';
import { updateClients, getBrandCustom } from '../../../store/actions';
import FormClientBrandCustom from './form-BrandCustom';
import Swal from 'sweetalert2';
import PageTitle from '../../../components/Common/MetaTagsHelper/metaTagsHelper';
import { Container } from 'reactstrap';
import usePageTitle from '../../../common/hooks/usePageTitle';

const BrandCustomList = (props: any) => {
    const dispatch = useDispatch();
    const { brandCustom } = useSelector((state: any) => state.clients);
    const PageTitleBC = usePageTitle(props.location.pathname);

    useEffect(() => {
        dispatch(getBrandCustom());
    }, []);

    const handleUpdateClient = (client: any) => {
        dispatch(updateClients({ newObject: client }));
        Swal.fire({
            icon: 'success',
            title: 'Updated!',
            text: 'New items have been updated successfully!',
        });
    };
    const handleCancel = (id: any) => {
        dispatch(getBrandCustom());
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="pageContent" style={{ padding: '1px 15px 0 1px' }}>
                    <PageTitle>
                        <title>{PageTitleBC.replace(/-/g, ' ')} | {getNameClient()}</title>
                    </PageTitle>
                    <Container fluid>
                        <div className="container_brandCustom">
                            <FormClientBrandCustom selectedRow={brandCustom} onUpdateClient={handleUpdateClient} onCancel={handleCancel} />
                        </div>
                    </Container>
                </div>
            </div>
        </React.Fragment>
    );
};

export default BrandCustomList;
